import React from 'react'
import { Palette } from 'lucide-react'
import GenericTabelaPage from '../../components/tabelas/GenericTabelaPage'
import { coresApi } from '../../api/tabelasBasicas'

const CoresPage: React.FC = () => {
  return (
    <GenericTabelaPage
      titulo="Cores"
      breadcrumb="Tabelas › Básicas"
      icon={<Palette size={17} />}
      cdMaxLen={10}
      nmMaxLen={30}
      api={coresApi}
    />
  )
}

export default CoresPage
